import React from "react";

import styles from "./Tooltip.module.css";

interface Props {
  message: JSX.Element | null;
}

const Tooltip: React.FC<Props> = (props) => {
  const { message } = props;

  if (message === null) return null;

  return <span className={`${styles.TooltipText}`}>{message}</span>;
};

export default Tooltip;
